<template>
  <b-row>
    <b-col cols="10">
      <b-media tag="li">
        <template v-if="getOrganizationBanner" v-slot:aside>
          <b-card-img style="object-fit: initial; height: 64px; width: 64px" :src="getOrganizationBanner"></b-card-img>
        </template>
        <template v-else v-slot:aside>
          <span class="text-dark pt-3 pl-3" id="media-wrapper">
            <font-awesome-icon class="align-middle" icon="landmark" size="2x"/>
          </span>
        </template>
        <h5 class="mt-0  mb-3 text-left">
          <b-link
            class="title"
            :to="{ name: 'organizationView', params: { id: organization.id }}"
            target="_blank"
          >
            {{ getTitle }}
          </b-link>
        </h5>
        <p class="mb-0 text-left">
          <b-row>
            <b-col cols="6" lg="12" md="12" sm="12" xs="12">
              <b-row>
                <b-col
                  class="info col-4 pr-0"
                  title="Creation date"
                  v-b-tooltip.hover.top
                >
                  <font-awesome-icon icon="calendar-alt" class="mr-1" /> {{ organization.created | utcLocalDate }}
                </b-col>
                <b-col
                  v-if="organization.country"
                  class="info col-4 px-0"
                  title="The country where the organization is hosted"
                  v-b-tooltip.hover.top
                >
                  <font-awesome-icon icon="map-marker-alt" class="mr-1" /> {{ organization.country }}
                </b-col>
                <b-col
                  v-if="organization.url && organization.url !== ''"
                  class="info col-4 px-0"
                  title="Visit website"
                  v-b-tooltip.hover.top
                >
                  <font-awesome-icon icon="external-link-alt" class="mr-1" />
                  <a class="website" :href="getOrganizationExternalLink" target="_blank"><b>Website</b></a>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </p>
      </b-media>
    </b-col>
    <b-col
      v-if="organization.rights === 'OWN'"
      cols="2"
      class="d-flex justify-content-end align-items-center"
    >
      <router-link :to="{ name: 'organizationEdit', params: { id: organization.id } }">
        <div
          class="action mr-3"
          v-b-tooltip.hover.top
          title="Edit"
          @click="editOrganisation(organization.id)"
          target="_blank"
        >
          <font-awesome-icon icon="edit" class="edit" />
        </div>
      </router-link>
      <b-link
        class="action"
        v-b-tooltip.hover.top
        title="Delete"
        @click="showMsgDelete(organization.id, organization.name)"
        target="_blank"
      >
        <font-awesome-icon icon="trash-alt" class="delete" />
      </b-link>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: 'OrganizationMedia',
  props: {
    'organization': Object
  },
  computed: {
    isOwner: function () {
      if (this.type === 'OWN') {
        return true
      } else if (this.type === 'PUBLIC') {
        return false
      } else if (this.type === 'SHARE') {
        return false
      } else {
        return false
      }
    },
    getTitle () {
      let title = this.organization.name
      if (title) {
        return title
      }
      return '<Untitled>'
    },
    getOrganizationExternalLink () {
      let link = this.organization.url
      if (link !== undefined && link.startsWith('https')) {
        return link
      }
      if (link !== undefined && link.startsWith('www')) {
        return '//' + link
      }
      if (link !== undefined && link.startsWith('http')) {
        return link
      }
      return ''
    },
    getOrganizationBanner () {
      let image = this.organization.bannerUrl
      return image
    }
  },
  methods: {
    showMsgDelete (orgId, orgTitle) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this organisation.', {
        title: 'Are you sure you want to delete ' + orgTitle + '?',
        size: 'bg',
        buttonSize: 'bg',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            this.deleteOrganization(orgId)
          } else {}
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    deleteOrganization (orgId) {
      this.$store.dispatch('deleteOrganizationEntity', orgId).then(
        data => {
          window.location.reload()
        })
    },
    editOrganisation (orgId) {
      this.$store.push({ name: 'organizationEdit', params: { id: orgId } })
    }
  }
}
</script>

<style lang="scss" scoped>
  #media-wrapper {
    width: 64px;
    height: 64px;
  }

  a.website {
    color: black;
  }

  .title {
    overflow:hidden;
    white-space:nowrap;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 10px;
    display: block;
    color: #000;
  }

  .title:hover{
    text-decoration: none;
    color: #EE861D;
    -webkit-transition: all 0.4s;
    transition: all 0.4s;
  }

  .info {
    max-width: 136px;
    overflow:hidden;
    white-space:nowrap;
    text-overflow: ellipsis
  }

  .action {
    color: #000;

    .edit:hover {
      color: #545b62;
    }

    .delete:hover {
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/organizations/OrganizationMedia.vue